import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/Dashboard';
import AdminUser from '@/components/admin/User';
import AdminRole from '@/components/admin/Role';
import AdminPermission from '@/components/admin/Permission';
import AdminLink from '@/components/admin/Link';
import AdminStats from '@/components/admin/Stats';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/dashboard',
      component: Dashboard
    },
    {
      path: '/admin/user',
      component: AdminUser
    },
    {
      path: '/admin/role',
      component: AdminRole
    },
    {
      path: '/admin/permission',
      component: AdminPermission
    },
    {
      path: '/link/dynamic',
      component: AdminLink
    },
    {
      path: '/link/stats',
      component: AdminStats
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js